interface AdminKpiCardProps {
  label: string;
  value: string | number;
  sub?: string;
  accent?: 'default' | 'green' | 'amber' | 'red';
}

const ACCENT_CLASSES = {
  default: 'text-slate-900',
  green: 'text-emerald-600',
  amber: 'text-amber-600',
  red: 'text-rose-600',
} as const;

export function AdminKpiCard({ label, value, sub, accent = 'default' }: AdminKpiCardProps): JSX.Element {
  return (
    <div className="card p-5">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <p className={`mt-2 text-3xl font-semibold tabular-nums ${ACCENT_CLASSES[accent]}`}>{value}</p>
      {sub !== undefined ? <p className="mt-1 text-xs text-slate-500">{sub}</p> : null}
    </div>
  );
}
